module.exports = __webpack_public_path__ + "static/media/logopaston.93aa7819.png";